<doka-modal-wrapper (close)="closeModal()">
  <ng-template #title>
    <div class="flex flex-col gap-1">
      <span class="text-xl font-semibold">{{ titleKey() | i18nextEager }}</span>
      <span class="text-text-ultra-light font-light">{{
        subtitleKey() | i18nextEager
      }}</span>
    </div>
  </ng-template>
  <ng-template #content>
    @if (isLoading()) {
      <div class="flex justify-center items-center py-10">
        <app-spinner />
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="flex flex-col gap-lg">
          <doka-number-input
            [readOnly]="isYearReadonly()"
            formControlName="year"
            min="2000"
            [label]="'Dashboard.FiscalYearDialog.Year' | i18nextEager"
            data-testid="create-fiscal-year-dialog-year-input"
          />

          <app-input-date-picker
            formControlName="latestPlanSubmissionDate"
            [labelText]="'Dashboard.FiscalYearDialog.Deadline' | i18nextEager"
            data-testid="create-fiscal-year-dialog-deadline-input"
          />

          @if (hasCountrySelection()) {
            <div class="flex flex-col gap-sm">
              <span class="font-semibold">{{ "MasterData.PlansGrid.Countries" | i18nextEager }}</span>
              <app-country-checkbox-list
                [options]="countryOptions()"
                [(selectedIds)]="selectedCountryIds"
                testIdPrefix="create-fiscal-year-dialog"
              />
            </div>
          }
        </div>
      </form>
    }
  </ng-template>

  <ng-template #footer>
    <div class="flex w-full gap-md pt-4 items-center justify-end">
      <doka-button (click)="closeModal()" color="secondary">{{ "Common.Cancel" | i18nextEager }}</doka-button>
      <doka-button
        type="submit"
        (click)="submit()"
        color="primary"
        [disabled]="form.invalid || isLoading() || (hasCountrySelection() && selectedCountryIds().size === 0)"
        data-testid="create-fiscal-year-dialog-save-button"
      >
        {{ "Common.Save" | i18nextEager }}
      </doka-button>
    </div>
  </ng-template>
</doka-modal-wrapper>
